import React from 'react';
import QRCode from 'qrcode.react';

class QRCodeTool extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
    }
    render() {
        return (
            <div>
                {this.props.location.search.substring(3)} <br />
                <QRCode value={this.props.location.search.substring(3)} renderAs="canvas" />
            </div>
        )
    }
}
export default QRCodeTool